mainApp.component('scimProvisioning', {
    templateUrl: '/public/components/scim-provisioning.component.html',
     bindings: {
        model: '=',
        changesListener: '&'
     },
     controller: ['$scope', 'CopyToClipboardService', function($scope, CopyToClipboardService)
     {
         var ctrl = this;
         ctrl.baseUrl = null;
         ctrl.$onInit = function(){
             ctrl.hasChanges = false;
             getBaseUrl();
         }

									var hasChanges = function () {
													return !angular.equals(ctrl.model.scimProvisioningEnabled, ctrl.original.scimProvisioningEnabled) ||
																	!angular.equals(ctrl.model.tempBearerToken, ctrl.original.tempBearerToken) && ctrl.original.tempBearerToken != undefined;
     				};

         ctrl.$doCheck = function() {
             if (!ctrl.changesListener)
                 return;
             if(modelNotInitiatedYet() || ctrl.original == null){
             				return;
													}
             const isChangedNow = hasChanges();

             //check if listener was already called and updates about having changes
             if (ctrl.hasChanges === isChangedNow)
                 return;

             ctrl.hasChanges = isChangedNow;
             ctrl.changesListener({
                 isDirty: ctrl.hasChanges,
                 componentName: 'scimProvisioning'
             });
         }

								$scope.$on('modelReloadedEvent', function (event, data) {
												getBaseUrl();
								});

         function modelNotInitiatedYet(){
													return Object.keys(ctrl.model).length === 0 && ctrl.model.constructor === Object
									}

								function reload() {
												if(modelNotInitiatedYet()){
																ctrl.model.scimProvisioningEnabled = false;
																ctrl.model.baseUrl = ctrl.baseUrl;
																ctrl.model.tempBearerToken = generateId(20);
												}

										ctrl.original = angular.copy(ctrl.model);
										ctrl.original.tempBearerToken = undefined;
								}
								   ctrl.openLDAPPopup = function() {
         									if(ctrl.model.scimProvisioningEnabled){
												$scope.$root.openPopup('ldapDisabledDlg')
											}
								   }

								   ctrl.closeLDAPPopup = (disable) => {
									   ctrl.model.scimProvisioningEnabled = disable;
									   $scope.$root.closePopup('ldapDisabledDlg')
		 						}

									ctrl.copyToClipboard = (paramName) => {
													let message;
													switch (paramName) {
																	case 'Base Url':
																					CopyToClipboardService.copy(ctrl.model.baseUrl);
																					message = paramName + " copied";
																					$scope.$root.showNotification('success', message, message);
																					break;
														case 'Bearer Token':
																					CopyToClipboardService.copy(ctrl.model.tempBearerToken);
																					message = paramName + " copied";
																					$scope.$root.showNotification('success', message, message);
																					break;
																	default:
																					return '';
													}

									}

									function dec2hex (dec) {
													return dec.toString(16).padStart(2, "0");
									}

									ctrl.generateBearerToken = function() {
													let token = generateId(20);
													ctrl.model.tempBearerToken = token;
									}

									// generateId :: Integer -> String
									function generateId (len) {
													var arr = new Uint8Array((len || 40) / 2);
													window.crypto.getRandomValues(arr);
													return Array.from(arr, dec2hex).join('');
									}

									function getBaseUrl () {
												if(ctrl.baseUrl == null){
																getBaseUrlFromServer();
												}
												else{
																reload();
												}
									}
									function getBaseUrlFromServer () {
													store.fetch({
																	method: 'GET',
																	path:"/getScimBaseUrl?accountId=" + $scope.$root.accountId,
																	success: function (response) {
																					ctrl.baseUrl = response.data.url;
																					reload()
																	}
													});
									}
     }]
});
